import { Modal, Text, Button, Group } from "@mantine/core";
import { useNavigate } from "react-router-dom";

interface ShortlistModalProps {
  opened: boolean;
  onClose: () => void;
  companyName?: string;
}

export default function ShortlistModal({ opened, onClose, companyName }: ShortlistModalProps) {
  const navigate = useNavigate();

  const handleSignUp = () => {
    onClose();
    navigate("/signup");
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={`Shortlist ${companyName || "Company"}`}
      centered
      size="md"
      styles={{
        title: {
          fontSize: "20px",
          fontWeight: 600,
        },
      }}
    >
      <Text size="sm" c="slate.6" mb="xl">
        Sign up for free to shortlist companies, track interesting partners, and express your interest when you're ready
        to connect.
      </Text>

      <Group justify="flex-end" gap="md">
        <Button variant="outline" color="gray" onClick={onClose}>
          Cancel
        </Button>
        <Button onClick={handleSignUp}>Sign Up</Button>
      </Group>
    </Modal>
  );
}
